module.exports = __webpack_public_path__ + "static/mobile-721f0765b334e0d74ed7a55751bcda80.svg";